import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

export class KeyDateDetail {
  static getEmpty(): KeyDateDetail {
    return new KeyDateDetail(null, '', '', '', '', '');
  }

  constructor(
    private _date: NgbDate,
    private _priority: string,
    private _anchorDate: string,
    private _offset: string,
    private _calendar: string,
    private _rollConvention: string
  ) {
    if (this._date && Object.keys(this._date).includes('hour')) {
      this._date = new NgbDate(
        this._date.year,
        this._date.month,
        this._date.day
      );
    }
  }

  get date(): NgbDate {
    return this._date;
  }

  get priority(): string {
    return this._priority;
  }

  get anchorDate(): string {
    return this._anchorDate;
  }

  get offset(): string {
    return this._offset;
  }

  get calendar(): string {
    return this._calendar;
  }

  get rollConvention(): string {
    return this._rollConvention;
  }

  toString(): string {
    // Need to replace null values with empty strings, otherwise in some cases
    // the recorded snapshot or the current state inexplicably ends up having empty strings
    // and that causes the snapshot comparison to fail
    return JSON.stringify(this, (key, value) =>
      value === null && key !== '_date' ? '' : value
    );
  }
}
